import * as React from "react";
import type { SVGProps } from "react";
const SvgYoutube = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <g clipPath="url(#youtube_svg__a)">
      <path
        fill="#fff"
        d="M12 4.7c.855 0 1.732.023 2.582.058l1.004.048.961.057.9.062.822.063a3.802 3.802 0 0 1 3.494 3.423l.04.425.075.91c.07.943.122 1.971.122 2.954 0 .983-.052 2.011-.122 2.955l-.075.91c-.013.145-.026.287-.04.424a3.802 3.802 0 0 1-3.495 3.423l-.82.064-.9.062-.962.056-1.004.048c-.85.036-1.727.058-2.582.058-.855 0-1.732-.022-2.582-.058l-1.004-.048-.961-.056-.9-.062-.822-.064a3.802 3.802 0 0 1-3.494-3.423l-.04-.424-.075-.91A40.664 40.664 0 0 1 2 12.7c0-.982.052-2.011.122-2.954l.075-.91c.013-.145.026-.287.04-.425A3.802 3.802 0 0 1 5.73 4.988l.821-.063.9-.062.962-.057 1.004-.048A62.69 62.69 0 0 1 12 4.7Zm0 2a60.7 60.7 0 0 0-2.5.056l-.978.047-.939.056-.882.06-.808.063a1.802 1.802 0 0 0-1.666 1.622C4.11 9.814 4 11.319 4 12.7c0 1.382.11 2.887.227 4.096.085.872.777 1.55 1.666 1.623l.808.062.882.06.939.056.978.047c.826.035 1.675.056 2.5.056s1.674-.021 2.5-.056l.978-.047.939-.055.882-.06.808-.063a1.802 1.802 0 0 0 1.666-1.623c.117-1.209.227-2.714.227-4.096 0-1.382-.11-2.887-.227-4.095a1.802 1.802 0 0 0-1.666-1.623l-.808-.063-.882-.06-.939-.056-.978-.047A60.7 60.7 0 0 0 12 6.7Zm-2 3.575a.6.6 0 0 1 .819-.559l.081.04 4.2 2.425a.6.6 0 0 1 .085.98l-.085.059-4.2 2.425a.6.6 0 0 1-.893-.43l-.007-.09v-4.85Z"
      />
    </g>
    <defs>
      <clipPath id="youtube_svg__a">
        <path fill="#fff" d="M0 .7h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgYoutube;
